import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const mapModule = basic.module({
  id: "map-module",
  label: "Map Module",
  description: "A map module, use it to display your location to your visitors.",
  content: withUniqueClass(
    "map-module",
    (cls, h) => {
      const { coverageAreas } = h.company();


      console.log(coverageAreas)

      return `
      <div class="${cls}">
        <iframe
          class="${cls}__frame"
          width="100%"
          height="600"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=1%20Grafton%20Street,%20Dublin,%20Ireland+(My%20Business%20Name)&t=&z=14&ie=UTF8&iwloc=B&output=embed"
        ></iframe>
      </div>
      <style>
        .${cls} {
          width: 100%;
          overflow: hidden;
        }
        .${cls}__frame {
          width: 100%;
          height: 600px;
          border: none;
          display: block;
        }
      </style>
    `
    }
  ),
});